/**
 * Kleiner History-Router. Pfade sind relativ zum <base href> (BASE_PATH),
 * damit die App auch unter einem Unterpfad hinter dem Proxy funktioniert.
 */
const basePath = new URL(document.baseURI).pathname.replace(/\/$/, "");

function currentPath(): string {
  const path = location.pathname.startsWith(basePath)
    ? location.pathname.slice(basePath.length)
    : location.pathname;
  return path || "/";
}

class Router {
  path = $state(currentPath());
  query = $state(new URLSearchParams(location.search));

  constructor() {
    window.addEventListener("popstate", () => this.sync());
  }

  private sync(): void {
    this.path = currentPath();
    this.query = new URLSearchParams(location.search);
  }

  /** Navigiert (mit View Transition, wo verfügbar). */
  go(to: string, options: { replace?: boolean; transition?: boolean } = {}): void {
    const url = basePath + (to.startsWith("/") ? to : `/${to}`);
    const apply = () => {
      if (options.replace) history.replaceState(null, "", url);
      else history.pushState(null, "", url);
      this.sync();
    };
    const doc = document as Document & { startViewTransition?: (cb: () => void) => unknown };
    const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (options.transition !== false && doc.startViewTransition && !reduce) doc.startViewTransition(apply);
    else apply();
  }

  back(fallback = "/"): void {
    if (history.length > 1) history.back();
    else this.go(fallback, { replace: true });
  }

  /** Prüft ein Muster wie "/setlists/:id" und liefert die Parameter. */
  match(pattern: string): Record<string, string> | null {
    const want = pattern.split("/").filter(Boolean);
    const have = this.path.split("/").filter(Boolean);
    if (want.length !== have.length) return null;
    const params: Record<string, string> = {};
    for (let i = 0; i < want.length; i++) {
      const w = want[i]!;
      const h = decodeURIComponent(have[i]!);
      if (w.startsWith(":")) params[w.slice(1)] = h;
      else if (w !== h) return null;
    }
    return params;
  }
}

export const router = new Router();
